export const TAB_VARIANTS = {
    lift: 'lift',
    sub: 'sub',
    underline: 'underline',
    header: 'header',
} as const;

export type TabVariant = (typeof TAB_VARIANTS)[keyof typeof TAB_VARIANTS];

export interface VariantClasses {
    tablist: string;
    tab: string;
    activeTab: string;
    inactiveTab: string;
}

const UNDERLINE_CLASSES: VariantClasses = {
    tablist: 'flex flex-wrap gap-7 border-b border-mp-border',
    tab: '-mb-px border-b-2 px-0.5 py-3 text-sm font-medium transition-colors motion-reduce:transition-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-mp-link',
    activeTab: 'border-mp-primary text-mp-link',
    inactiveTab: 'border-transparent text-mp-muted hover:text-mp-foreground',
};

export const VARIANT_CLASSES: Record<TabVariant, VariantClasses> = {
    [TAB_VARIANTS.lift]: {
        tablist: 'flex flex-wrap border-b border-mp-border',
        tab: '-mb-px inline-flex h-10 items-center justify-center rounded-t-lg border px-4 text-sm transition-colors motion-reduce:transition-none focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-mp-link',
        activeTab: 'border-x-mp-border border-t-mp-border border-b-mp-surface bg-mp-surface text-mp-foreground',
        inactiveTab: 'border-transparent text-mp-muted hover:text-mp-foreground',
    },
    [TAB_VARIANTS.sub]: {
        tablist: 'mb-4 inline-flex w-fit rounded-lg bg-mp-border p-0.5',
        tab: 'rounded-md px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mp-primary',
        activeTab: 'bg-mp-surface text-mp-foreground shadow',
        inactiveTab: 'text-mp-foreground/70',
    },
    [TAB_VARIANTS.underline]: UNDERLINE_CLASSES,
    // For DetailPageHeader's `tabs`: the header band's bottom border is the baseline the tabs sit on.
    [TAB_VARIANTS.header]: {
        ...UNDERLINE_CLASSES,
        tablist: 'flex flex-wrap gap-7',
    },
};
